export default {
    patchNote: "Примечания к патчу",
    currentPatchNote: "Описание текущей версией",
    newPatchNote: "Описание новой версии",
}